import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "modal-wrapper scroll-wrapper"
}
const _hoisted_3 = {
  key: 0,
  class: "badge"
}
const _hoisted_4 = {
  key: 0,
  class: "lot-desktop-tabs"
}
const _hoisted_5 = { class: "lot-desktop-tab" }
const _hoisted_6 = {
  key: 0,
  class: "tab-border"
}
const _hoisted_7 = {
  key: 0,
  class: "lot-desktop-tab"
}
const _hoisted_8 = {
  key: 0,
  class: "tab-border"
}
const _hoisted_9 = {
  key: 1,
  class: "lot-desktop-tab"
}
const _hoisted_10 = {
  key: 0,
  class: "tab-border"
}
const _hoisted_11 = { class: "lot-details" }
const _hoisted_12 = {
  key: 0,
  class: "blocks-wr"
}
const _hoisted_13 = { class: "block block-lot-details" }
const _hoisted_14 = {
  key: 0,
  class: "title"
}
const _hoisted_15 = {
  key: 1,
  class: "block"
}
const _hoisted_16 = { class: "lot-title-mobile" }
const _hoisted_17 = {
  key: 0,
  class: "lot-reserve-tabs"
}
const _hoisted_18 = {
  key: 2,
  class: "row-wr"
}
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = { class: "row-value" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "row-value" }
const _hoisted_23 = { class: "row secondary" }
const _hoisted_24 = { class: "row-value" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "row-value" }
const _hoisted_27 = { class: "row secondary" }
const _hoisted_28 = {
  key: 1,
  class: "row-value"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "row-value" }
const _hoisted_31 = { class: "row secondary" }
const _hoisted_32 = {
  key: 0,
  class: "builder-package-card"
}
const _hoisted_33 = { class: "builder-card-logo-wr" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = {
  key: 1,
  class: "builder-card-name"
}
const _hoisted_36 = { class: "builder-documents-icon" }
const _hoisted_37 = {
  key: 1,
  class: "lot-img"
}
const _hoisted_38 = {
  key: 0,
  class: "lot-img-title"
}
const _hoisted_39 = ["viewBox"]
const _hoisted_40 = ["d"]
const _hoisted_41 = {
  key: 1,
  class: "content-documents"
}
const _hoisted_42 = {
  key: 0,
  class: "documents-group"
}
const _hoisted_43 = {
  key: 1,
  class: "documents-group"
}
const _hoisted_44 = {
  key: 1,
  class: "controls"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close,
    classes: $setup.getModalClasses(),
    "transition-name": $props.transitionName
  }, {
    content: _withCtx(() => [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-title", { 'land-options-available': $setup.hasHouseAndLandPackage }])
            }, [
              _createTextVNode("Lot " + _toDisplayString($props.lot.lotId.title), 1),
              ($setup.hasHouseAndLandPackage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Home & Land Package"))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["content-block scroll-wrapper", { 'land-options-available': $setup.hasHouseAndLandPackage }])
            }, [
              ($setup.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["lot-desktop-title", { 'lot-tab-active': $setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeTab($setup.TabsEnum.LOT_DETAILS)))
                      }, "Lot Details", 2),
                      ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true)
                    ]),
                    ($setup.hasLotDocuments)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["lot-desktop-title", { 'lot-tab-active': $setup.isActiveTab($setup.TabsEnum.DOCS) }]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab($setup.TabsEnum.DOCS)))
                          }, "Documents", 2),
                          ($setup.isActiveTab($setup.TabsEnum.DOCS))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.canCreateHomeAndLandPackage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["lot-desktop-title", { 'lot-tab-active': $setup.isActiveTab($setup.TabsEnum.HOME_DESIGNS) }]),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab($setup.TabsEnum.HOME_DESIGNS)))
                          }, "Home Designs", 2),
                          ($setup.isActiveTab($setup.TabsEnum.HOME_DESIGNS))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                            : _createCommentVNode("", true),
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "button button approve" }, "NEW", -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) || !$setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        ($setup.isDesktop)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Lot Details"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", { class: "stage-back-wr" }, [
                                _createElementVNode("button", {
                                  class: "button-with-icon back",
                                  onClick: $setup.close
                                }, "BACK")
                              ]),
                              _createElementVNode("div", _hoisted_16, "Lot " + _toDisplayString($props.lot.lotId.title), 1),
                              (!$setup.isDesktop)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["button", !$setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) ? 'question' : 'default primary']),
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab($setup.TabsEnum.LOT_DETAILS)))
                                    }, "Lot details", 2),
                                    ($setup.hasLotDocuments)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: _normalizeClass(["button", !$setup.isActiveTab($setup.TabsEnum.DOCS) ? 'question' : 'default primary']),
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab($setup.TabsEnum.DOCS)))
                                        }, "Docs", 2))
                                      : _createCommentVNode("", true),
                                    ($setup.canCreateHomeAndLandPackage)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: _normalizeClass(["button home-designs-tab-btn", !$setup.isActiveTab($setup.TabsEnum.HOME_DESIGNS) ? 'question' : 'default primary']),
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.changeTab($setup.TabsEnum.HOME_DESIGNS)))
                                        }, [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode("Home designs", -1),
                                          _createElementVNode("button", { class: "button approve" }, "New", -1)
                                        ]))], 2))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])),
                        ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              ($setup.isDesktop)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-label" }, "Stage", -1)),
                                    _createElementVNode("div", _hoisted_20, _toDisplayString($props.lot.stageId.title), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_21, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-label" }, "Street Name", -1)),
                                _createElementVNode("div", _hoisted_22, _toDisplayString($props.lot.lotId.streetName || "--"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row-label" }, "Frontage", -1)),
                                _createElementVNode("div", _hoisted_24, _toDisplayString($props.lot.lotId.blockWidth ? `${$setup.formatPrice($props.lot.lotId.blockWidth, false)} m` : "Irregular"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row-label" }, "Size", -1)),
                                _createElementVNode("div", _hoisted_26, _toDisplayString($setup.formatPrice($props.lot.lotId.size, false)) + " sqm", 1)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row-label" }, "Price", -1)),
                                ($props.estate.hidePrice)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "row-value highlighted",
                                      onClick: $setup.toContact
                                    }, "Request pricing"))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString($setup.formatPrice($props.lot.lotId.price)), 1))
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row-label" }, "Est. Registration", -1)),
                                _createElementVNode("div", _hoisted_30, _toDisplayString($setup.formatDate($props.lot.lotId.registrationDate, "MMM YYYY")), 1)
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row-label" }, "Status", -1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["badge", $setup.getLotCustomerMapStatusClass($props.lot.lotId.status)])
                                }, _toDisplayString($setup.getCustomerFacingLotStatusLabel($props.lot.lotId.status)), 3)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS) && $setup.hasHouseAndLandPackage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              ($setup.assignedBuilderLogo)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "builder-card-logo",
                                    src: $setup.assignedBuilderLogo,
                                    alt: $setup.assignedBuilderName ? `${$setup.assignedBuilderName} logo` : 'Builder logo'
                                  }, null, 8, _hoisted_34))
                                : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($setup.assignedBuilderName), 1))
                            ]),
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "builder-card-pill" }, "Home & Land Package", -1)),
                            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "builder-card-description" }, "This lot is available as a home & land package. For more information, please contact our sales team.", -1)),
                            ($setup.hasBuilderDocuments)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "button builder-documents-button",
                                  type: "button",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.changeTab($setup.TabsEnum.DOCS)))
                                }, [
                                  _createElementVNode("span", _hoisted_36, [
                                    _createVNode($setup["Folder"], {
                                      size: 20,
                                      "stroke-width": 1.5
                                    })
                                  ]),
                                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "View Package Info", -1))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : ($setup.isActiveTab($setup.TabsEnum.LOT_DETAILS))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              ($setup.isDesktop)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Lot Shape"))
                                : _createCommentVNode("", true),
                              (_openBlock(), _createElementBlock("svg", {
                                class: "item-wr svg-img",
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                version: "1.1",
                                viewBox: `0 0 ${$props.lot.size.width} ${$props.lot.size.height}`
                              }, [
                                _createElementVNode("path", {
                                  class: "item-path",
                                  d: $props.lot.path
                                }, null, 8, _hoisted_40)
                              ], 8, _hoisted_39))
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                ($setup.isActiveTab($setup.TabsEnum.DOCS))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      ($props.lot.lotId.documents && $props.lot.lotId.documents.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "documents-title" }, "Lot Documents", -1)),
                            _createVNode($setup["BuilderLotDocuments"], {
                              documents: $props.lot.lotId.documents,
                              "show-title": false
                            }, null, 8, ["documents"])
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.hasBuilderDocuments)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "documents-title" }, "Builder Documents", -1)),
                            _createVNode($setup["BuilderLotDocuments"], {
                              documents: $props.lot.lotId.builderDocuments,
                              "show-title": false
                            }, null, 8, ["documents"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ($setup.canCreateHomeAndLandPackage && $setup.isActiveTab($setup.TabsEnum.HOME_DESIGNS))
                ? (_openBlock(), _createBlock($setup["BuilderGetStartedTab"], {
                    key: 1,
                    buttonDisabled: $setup.props.buttonsDisabled,
                    onOnRequestQuote: $setup.onRequestQuote
                  }, null, 8, ["buttonDisabled"]))
                : _createCommentVNode("", true)
            ], 2),
            ($setup.canCreateHomeAndLandPackage)
              ? (_openBlock(), _createBlock($setup["BuilderControlsButtons"], {
                  key: 0,
                  lot: $props.lot.lotId,
                  isEmbedded: $setup.props.embedded,
                  isInitialHoldDisabled: $setup.isInitialHoldDisabled,
                  landOptionsAvailable: $setup.canCreateHomeAndLandPackage,
                  buttonsDisabled: $setup.props.buttonsDisabled,
                  hideRequestHold: $setup.hasAssignedHouseAndLandPackage,
                  onContact: $setup.toContact,
                  onHold: $setup.hold,
                  onRequestQuote: $setup.onRequestQuote,
                  onReserve: $setup.reserve
                }, null, 8, ["lot", "isEmbedded", "isInitialHoldDisabled", "landOptionsAvailable", "buttonsDisabled", "hideRequestHold"]))
              : _createCommentVNode("", true),
            (!$setup.canCreateHomeAndLandPackage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  ($props.lot.lotId.status === $setup.LotStatus.AVAILABLE && $setup.isInitialHoldDisabled && !$setup.hasHouseAndLandPackage)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["button default primary reserve", { disabled: $setup.disabledButton || $setup.props.buttonsDisabled }]),
                        onClick: $setup.reserve,
                        disabled: $setup.disabledButton || $setup.props.buttonsDisabled
                      }, "Reserve", 10, _hoisted_45))
                    : _createCommentVNode("", true),
                  ($props.lot.lotId.status === $setup.LotStatus.AVAILABLE && !$setup.isInitialHoldDisabled && !$setup.hasHouseAndLandPackage)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: _normalizeClass(["button default primary reserve", { disabled: $setup.disabledButton || $setup.props.buttonsDisabled }]),
                        onClick: $setup.hold,
                        disabled: $setup.disabledButton || $setup.props.buttonsDisabled
                      }, "Request a hold", 10, _hoisted_46))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button", [$setup.hasHouseAndLandPackage ? 'default primary reserve' : 'question', { 'mt-0': $props.lot.lotId.status !== $setup.LotStatus.AVAILABLE }, { disabled: $setup.props.buttonsDisabled }]]),
                    onClick: $setup.toContact,
                    disabled: $setup.props.buttonsDisabled
                  }, "Make enquiry", 10, _hoisted_47)
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["isOpen", "classes", "transition-name"]))
}